(function () {
  'use strict';

  var ELIGIBLE_HANDLES = {
    'light-pink-color-roses': true,
    'nude-color-roses': true,
    'white-rose-bouquet': true,
    'red-color-roses': true,
    'yellow-rose-bouquet': true,
    'fuchsia-rose-bouquet': true
  };

  function getProductData() {
    var node = document.querySelector('script[id^="ProductJson-"]');
    if (!node) return null;

    try {
      return JSON.parse(node.textContent || node.innerText || '{}');
    } catch (error) {
      return null;
    }
  }

  function buildValueBlock() {
    var block = document.createElement('div');
    block.className = 'ay-bouquet-value';
    block.setAttribute('data-ay-bouquet-value', '');

    block.innerHTML =
      '<div class="ay-bouquet-value__eyebrow">Included at no extra charge</div>' +
      '<div class="ay-bouquet-value__items">' +
        '<div class="ay-bouquet-value__item">' +
          '<span class="ay-bouquet-value__check" aria-hidden="true">✓</span>' +
          '<span>Premium wrapping included</span>' +
        '</div>' +
        '<div class="ay-bouquet-value__item">' +
          '<span class="ay-bouquet-value__check" aria-hidden="true">✓</span>' +
          '<span>Premium note card printing included</span>' +
        '</div>' +
      '</div>';

    return block;
  }

  function init() {
    if (!document.body || !document.body.classList.contains('template-product')) return;

    var product = getProductData();
    if (!product || !ELIGIBLE_HANDLES[product.handle]) return;

    var form = document.querySelector('.product-section[data-section-type="product-template"] form.variations_form.cart');
    if (!form || form.querySelector('[data-ay-bouquet-value]')) return;

    var selector = form.querySelector('.selector-container');
    if (!selector) return;

    form.insertBefore(buildValueBlock(), selector);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();